/** @format */

import {Trans} from 'react-i18next';

import {AvailableBusinessTariff} from 'features/tariffs/types';

import {ActiveBox, BusinessBox, PopularBadge, PremiumBox, StartBox, UltraBox} from './styles';

import startText from './images/start.svg';
import activeText from './images/active.svg';
import businessText from './images/business.svg';
import premiumText from './images/premium.svg';
import ultraText from './images/ultra.svg';

interface Props {
  id: AvailableBusinessTariff;
}

const TariffHeaders = ({id}: Props) => {
  switch (id) {
    case 'start':
      return (
        <StartBox>
          <img src={startText} alt={id} />
        </StartBox>
      );
    case 'active':
      return (
        <ActiveBox>
          <img src={activeText} alt={id} />
        </ActiveBox>
      );
    case 'business':
      return (
        <BusinessBox>
          <img src={businessText} alt={id} />
          <PopularBadge>
            <Trans>популярный</Trans>
          </PopularBadge>
        </BusinessBox>
      );
    case 'premium':
      return (
        <PremiumBox>
          <img src={premiumText} alt={id} />
        </PremiumBox>
      );
    case 'ultra':
      return (
        <UltraBox>
          <img src={ultraText} alt={id} />
        </UltraBox>
      );
    default:
      return null;
  }
};

export {TariffHeaders};
